import img1 from "../choose-us-img/spec-img.png"
import img2 from "../choose-us-img/spec-img1.png"
import img3 from "../choose-us-img/spec-img2.png"
 
 const ChooseData = 
    [
        {
            img:img1,
            heading:"Cross Country Drive",
            text:"Take your driving experience to the next level with  our top-notch vehicles for your cross-country adventures"
        },
   
        {
            img:img2,
            heading:"All Inclusive Pricing",
            text:"Get everything you need in one convenient, transparent price with our all-inclusive pricing policy."
        },
   
        {
            img:img3,
            heading:"No Hidden Charges",
            text:"Enjoy peace of mind with our no hidden charges policy. We believe in transparent and honest pricing."
        },
   
    ]

export default ChooseData;
